import { useScrollReveal } from "@/hooks/useScrollReveal";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function AccordionComponent({
  question,
  answer,
  isOpen,
  onClick,
  containerHeight = "lg:h-[183px] xl:h-[174px] 1xl:h-[200px]",
}) {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "bounce-up" : ""
      } w-full bg-white/0 rounded-[20px] outline outline-1 outline-neutral-400/25 overflow-hidden mb-[14px] my-auto`}
    >
      <div
        className="flex justify-between items-center p-6 cursor-pointer"
        onClick={onClick}
      >
        <div className="text-white text-lg lg:text-base xl:text-xl font-medium">
          {question}
        </div>

        <div className="p-1 bg-slate-600/20 rounded-[5px] flex justify-center items-center">
          {isOpen ? (
            <ChevronUp className="w-5 h-5 text-white" />
          ) : (
            <ChevronDown className="w-5 h-5 text-white" />
          )}
        </div>
      </div>

      {isOpen && answer && (
        <div
          className={`px-6 pb-6 textwhite text-sm lg:text-[13.2px] xl:text-base font-light ${containerHeight}`}
        >
          {answer}
        </div>
      )}
    </div>
  );
}
